import * as THREE from "three";

export function createLiquidWaveMaterial(textures) {
  const uniforms = {
    center: { value: new THREE.Vector2() },
    centerLocal: { value: new THREE.Vector2() },
    bounds: { value: new THREE.Vector4() },
    time: { value: 0 },
  };

  const material = new THREE.MeshStandardMaterial({
    map: textures.concreteBaseColor,
    normalMap: textures.concreteNormal,
    roughnessMap: textures.concreteRoughness,
    roughness: 0.55,
    color: 0xffffff,
    emissive: 0xa89887,
    emissiveIntensity: 0.2,
  });

  material.onBeforeCompile = (shader) => {
    shader.uniforms.uWaveCenter = uniforms.center;
    shader.uniforms.uWaveCenterLocal = uniforms.centerLocal;
    shader.uniforms.uWaveBounds = uniforms.bounds;
    shader.uniforms.uWaveTime = uniforms.time;
    shader.vertexShader = `
      uniform vec2 uWaveCenter;
      uniform vec2 uWaveCenterLocal;
      uniform vec4 uWaveBounds;
      uniform float uWaveTime;
      varying float vWaveHeight;
   ${shader.vertexShader}`;
    shader.vertexShader = shader.vertexShader.replace(
      "#include <begin_vertex>",
      `
         #include <begin_vertex>
         vec3 waveWorldPosition = (modelMatrix * vec4(transformed, 1.0)).xyz;
         float waveDistance = distance(waveWorldPosition.xz, uWaveCenter);
         float waveSpatialPhase = waveDistance * 24.0 / (1.0 + waveDistance * 0.45);
         float waveSpeed = 2.4 / (1.0 + waveDistance * 0.35);
         float waveFalloff = exp(-waveDistance * 1.25);
         vec2 waveLocalPosition = transformed.xz;
         vec2 reflectionLeft = vec2(2.0 * uWaveBounds.x - uWaveCenterLocal.x, uWaveCenterLocal.y);
         vec2 reflectionRight = vec2(2.0 * uWaveBounds.y - uWaveCenterLocal.x, uWaveCenterLocal.y);
         vec2 reflectionNear = vec2(uWaveCenterLocal.x, 2.0 * uWaveBounds.z - uWaveCenterLocal.y);
         vec2 reflectionFar = vec2(uWaveCenterLocal.x, 2.0 * uWaveBounds.w - uWaveCenterLocal.y);
         float reflectedDistance = min(
            min(distance(waveLocalPosition, reflectionLeft), distance(waveLocalPosition, reflectionRight)),
            min(distance(waveLocalPosition, reflectionNear), distance(waveLocalPosition, reflectionFar))
         );
         float reflectedWave = sin(reflectedDistance * 9.0 - uWaveTime * 0.9)
            * 0.008 * exp(-reflectedDistance * 0.35);
         float fluidNoise = (
            sin(waveWorldPosition.x * 13.0 + waveWorldPosition.z * 7.0 + uWaveTime * 1.3)
            + sin(waveWorldPosition.x * 6.0 - waveWorldPosition.z * 11.0 - uWaveTime * 0.8)
         ) * 0.003;
         float waveHeight = sin(waveSpatialPhase - uWaveTime * waveSpeed)
            * 0.028 * waveFalloff;
         waveHeight += reflectedWave + fluidNoise;
         transformed.y += waveHeight;
         vWaveHeight = waveHeight;
      `,
    );
    shader.fragmentShader = `
      varying float vWaveHeight;
   ${shader.fragmentShader}`;
    shader.fragmentShader = shader.fragmentShader.replace(
      "#include <color_fragment>",
      `
         #include <color_fragment>
         float waveDarken = min(vWaveHeight, 0.0) * 20.0;
         float waveBrighten = max(vWaveHeight, 0.0) * 5.0;
         diffuseColor.rgb *= 1.0 + waveDarken + waveBrighten;
      `,
    );
  };

  return { material, uniforms };
}
